import { handleAxiosError } from "../utils/errorHandler";
import axiosInstance from "./axiosInstance";

export const getPdfFaktura = async (invoiceNumber) => {
  try {
    const response = await axiosInstance.get(
      `/api/pdf?number=${invoiceNumber}`,
      {
        responseType: "blob", /// Zajišťuje, že odpověď je zpracována jako binární soubor
      }
    );

    // Vytvoření objektu Blob z přijatých dat
    const pdfBlob = new Blob([response.data], { type: "application/pdf" });
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl, "_blank");
    return { success: true };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Chyba při načítání PDF."
    );
    return { success: false, status, message };
  }
};
